import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dca3980c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]

import { computed, PropType } from "vue";
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from "tir-components";
import { ChevronDownIcon } from "tir-style-system/icons/solid";
import { TaskColumnModel, TaskSortingModel } from "../../models";
import { TaskViewElementEnum } from "@/components/tasks-kanban/enums";
import { Bars3BottomLeftIcon } from "tir-style-system/icons/outline";

// #region defineProps
/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-header',
  props: {
  /**Колонки */
  columns: { type: Array as PropType<TaskColumnModel[]> },
  /**Данные сортировки */
  sortData: { type: Object as PropType<TaskSortingModel> },
  /**Включить возможность сортировки */
  enableSorting: { type: Boolean, default: false },
  /**Настройки отображения */
  viewSettings: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: () => [
      TaskViewElementEnum.Namespace,
      TaskViewElementEnum.Queue,
      TaskViewElementEnum.Number,
      TaskViewElementEnum.Name,
      TaskViewElementEnum.Status,
      TaskViewElementEnum.Difficulty,
      TaskViewElementEnum.Priority,
      TaskViewElementEnum.EstimateTime,
      TaskViewElementEnum.WorkTime,
    ],
  },
  /**Загрузка при сортировке */
  isLoading: {
    type: Boolean,
    default: false,
  },
  /**Шапка таблицы на странице мониторинга */
  monitoringPage: { type: Boolean, default: false },
},
  emits: ["update:sortData"],
  setup(__props, { emit }) {

const props = __props;


// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region Переменные
/**Колонки по которым можно сортировать */
const sortingColumnsType = [
  TaskViewElementEnum.Number,
  TaskViewElementEnum.Name,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
];
// #endregion Переменные

// #region computed
/**Минимальная ширина */
const minWidth = computed(() => {
  const columnsCalcStr = props.columns.map((column) => column.MinWidth).join(" + ");

  return `calc(${columnsCalcStr} + ${0.75 * (props.columns.length - 1)}rem + 1.25rem)`;
});
/**Видимые колонки */
const visibleColumns = computed(() =>
  props.columns.filter((column) => props.viewSettings.includes(column.Type)),
);
// #endregion computed
let sortData = new TaskSortingModel(props.sortData);
// #region Функции
/**
 * Выбрать колонку по которой сортируются задачи
 * @param column Колонка
 */
const selectSortingColumn = (column: TaskColumnModel) => {
  switch (column.Type) {
    case TaskViewElementEnum.Number:
      sortData = new TaskSortingModel({
        OrderById: !sortData.OrderById,
      });
      break;
    case TaskViewElementEnum.Name:
      sortData = new TaskSortingModel({
        OrderByName: !sortData.OrderByName,
      });
      break;
    case TaskViewElementEnum.EstimateTime:
      sortData = new TaskSortingModel({
        OrderByEstimateTime: !sortData.OrderByEstimateTime,
      });
      break;
    case TaskViewElementEnum.WorkTime:
      sortData = new TaskSortingModel({
        OrderByWorkTime: !sortData.OrderByWorkTime,
      });
      break;
    case TaskViewElementEnum.Difficulty:
      sortData = new TaskSortingModel({
        OrderByDifficulty: !sortData.OrderByDifficulty,
      });
      break;
    case TaskViewElementEnum.Priority:
      sortData = new TaskSortingModel({
        OrderByPriority: !sortData.OrderByPriority,
      });
      break;
    case TaskViewElementEnum.Status:
      sortData = new TaskSortingModel({
        OrderByStatus: !sortData.OrderByStatus,
      });
      break;
    case TaskViewElementEnum.Queue:
      sortData = new TaskSortingModel({
        OrderByQueue: !sortData.OrderByQueue,
      });
      break;
  }
  emit("update:sortData", sortData);
};

const checkIsRotateChevron = (columnType: TaskViewElementEnum) => {
  if (!props.sortData) return false;

  switch (columnType) {
    case TaskViewElementEnum.Number:
      return !props.sortData.OrderById;
    case TaskViewElementEnum.Name:
      return !props.sortData.OrderByName;
    case TaskViewElementEnum.EstimateTime:
      return !props.sortData.OrderByEstimateTime;
    case TaskViewElementEnum.WorkTime:
      return !props.sortData.OrderByWorkTime;
  }
  return false;
};
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["task-header", { 'task-header__monitoring-page': props.monitoringPage }]),
      style: _normalizeStyle({ minWidth: minWidth.value })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColumns.value, (column) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['task-header__item', `align--${column.Align}`]),
          style: _normalizeStyle({
          width: column.Width,
          minWidth: column.MinWidth,
        }),
          key: column.Name
        }, [
          (column.Name)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                textContent: _toDisplayString(column.Name),
                class: "task-header__item-name"
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          (column.Icon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(column.Icon), {
                key: 1,
                class: "task-header__item-icon"
              }))
            : _createCommentVNode("", true),
          (__props.enableSorting && (column.Name || column.Icon))
            ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 2,
                class: "task-header__item-sort-button",
                variant: _unref(TirPmButtonVariantEnum).LinkState,
                size: _unref(TirPmButtonSizeEnum).Small,
                "is-loading": __props.isLoading,
                onClick: ($event: any) => (selectSortingColumn(column))
              }, {
                leftSlot: _withCtx(() => [
                  _createVNode(_unref(Bars3BottomLeftIcon), {
                    class: _normalizeClass([
                'task-header__item-sort-button-icon',
                { 'is-rotate': checkIsRotateChevron(column.Type) },
              ])
                  }, null, 8, ["class"])
                ]),
                _: 2
              }, 1032, ["variant", "size", "is-loading", "onClick"]))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ], 6)
  ]))
}
}

})